// Diccionario de traducciones para las pantallas de PADRES.
// Solo cubre el flujo de padres (login y paneles de profesor/admin
// siguen en español fijo, no forman parte de este alcance).

const translations = {
  es: {
    // Encabezado / panel principal
    panel_titulo: "Sistema de Citas",
    panel_bienvenido: "Bienvenido",
    panel_regresar: "← Regresar",
    panel_cerrar_sesion: "Cerrar sesión",
    panel_seleccione_servicio: "Seleccione un Servicio",
    panel_ver_mis_citas: "📋 Ver mis citas agendadas",
    panel_ingresar: "Ingresar",
    panel_cargando_servicios: "Cargando servicios...",
    panel_cargando_usuario: "Cargando usuario...",
    panel_idioma: "Idioma",

    // Lista de docentes (Colegio)
    lista_titulo: "Seleccione el docente con el que desea agendar su cita",
    lista_buscar: "🔍 Buscar docente...",
    lista_cargando: "Cargando docentes...",
    lista_docentes_de: "Docentes",
    lista_horarios_disponibles: "Horarios",
    lista_no_horarios: "No hay horarios disponibles",
    lista_ver_horarios: "Ver",
    lista_sin_horarios_btn: "Ver",

    // Kindergarten
    kinder_cargando: "Cargando profesores...",
    kinder_titulo: "Seleccione el Docente para Agendar su Cita",
    kinder_buscar: "Buscar profesor...",
    kinder_ver_horarios: "Ver",
    kinder_disponibles: "Horarios",

    // CDA (guías de grado)
    cda_bienvenida: "Bienvenidos Padre de Familia",
    cda_subtitulo:
      "Seleccione el Docente Guía del Grado en que se encuentra el Alumno.",
    cda_subtitulo2: "Solo puede seleccionar un docente para su cita.",
    cda_buscar: "🔍 Buscar docente...",
    cda_cargando: "Cargando...",
    cda_sin_foto: "Sin foto",
    cda_ver_horarios: "Ver",
    cda_sin_horarios: "Ver",
    cda_disponibles: "Horarios",
    cda_sin_resultados: "No se encontró ningún docente con ese nombre.",
    nivel_kinder: "Kinder",
    nivel_primaria: "Primaria",
    nivel_secundaria: "Secundaria",

    // Calendario / horarios del docente
    horarios_titulo: "Selecciona una Fecha Según Disponibilidad",
    horarios_fecha_seleccionada: "Horarios para el {fecha}",
    horarios_matutino: "☀️ Matutino",
    horarios_vespertino: "🌇 Vespertino",
    horarios_volver: "Regresar",

    // Reserva de cita
    reserva_confirmada_titulo: "¡Cita confirmada!",
    reserva_confirmada_subtitulo: "Tu cita fue registrada exitosamente",
    reserva_fecha: "📅 Fecha:",
    reserva_hora: "⏰ Hora:",
    reserva_alumno: "👦 Alumno:",
    reserva_grado: "🎓 Grado:",
    reserva_volver_inicio: "Regresar al inicio",
    reserva_detalles_titulo: "Detalles de la cita",
    reserva_nombre_alumno_label: "👦 Nombre del alumno",
    reserva_grado_label: "🎓 Grado",
    reserva_comentario_label: "📝 Comentario",
    reserva_confirmar_btn: "Confirmar Cita",
    reserva_confirmando: "Reservando...",
    reserva_volver: "Regresar",
    reserva_atencion_titulo: "Atención",
    reserva_atencion_texto: "Debes completar el nombre del alumno y el grado",
    reserva_error_titulo: "Error",
    reserva_error_texto: "No se pudo reservar la cita",

    // Mis citas
    miscitas_titulo: "📋 Mis Citas",
    miscitas_subtitulo: "Las citas que has agendado con los docentes.",
    miscitas_regresar: "← Regresar",
    miscitas_ver_pendientes: "📌 Ver pendientes",
    miscitas_ver_historial: "📚 Ver historial",
    miscitas_cargando: "Cargando...",
    miscitas_sin_pendientes: "No tienes citas pendientes.",
    miscitas_sin_historial: "No tienes citas en tu historial.",
    miscitas_alumno: "👦 Alumno:",
    miscitas_grado: "🎒 Grado:",
    miscitas_profesor: "👨‍🏫 Profesor:",
    miscitas_fecha: "📅 Fecha:",
    miscitas_hora: "🕒 Hora:",
    miscitas_nota: "💬 Nota:",
    miscitas_anterior: "‹ Anterior",
    miscitas_siguiente: "Siguiente ›",

    estado_pendiente: "Pendiente",
    estado_atendida: "Atendida",
    estado_no_asistio: "No asistió",
    estado_cancelada_admin: "Cancelada por administración",
    estado_cancelada_profesor: "Cancelada por el docente",
    estado_sin_estado: "Sin estado",

    // Plantilla "Portal Lateral"
    portal_inicio: "Inicio",
    portal_mis_citas: "Mis citas",
    portal_nueva_cita: "Nueva cita",
    portal_ayuda: "Ayuda",
    portal_padre_familia: "Padre de familia",
    portal_bienvenido: "¡Bienvenido",
    portal_que_deseas: "¿Qué te gustaría hacer hoy?",
    portal_agendar_titulo: "Agendar una nueva cita",
    portal_agendar_desc: "Selecciona el servicio, docente, fecha y hora que más te convenga.",
    portal_agendar_btn: "Comenzar",
    portal_vercitas_titulo: "Ver mis citas",
    portal_vercitas_desc: "Consulta el estado de tus citas agendadas.",
    portal_vercitas_btn: "Ver citas",
    portal_aviso_titulo: "Aviso importante",
    portal_aviso_texto:
      "Recuerda llegar 5 minutos antes de tu cita. Si no puedes asistir, avisa con anticipación al docente.",
    portal_servicios_titulo: "¿Qué tipo de cita deseas agendar?",
    portal_servicios_sub: "Selecciona el servicio que necesitas.",
    portal_continuar: "Continuar →",
    portal_duracion_nota: "Cada cita dura {min} minutos.",
    portal_info_estudiante: "Información del estudiante",
    portal_nombre_completo: "Nombre completo",
    portal_grado_curso: "Grado",
    portal_comentario_opcional: "Comentario (opcional)",
    portal_tipo_servicio: "Tipo de servicio:",
    portal_verificacion_nota: "Al confirmar, recibirás un correo de verificación con los detalles de tu cita.",
    portal_ayuda_titulo: "¿Necesitas ayuda?",
    portal_ayuda_texto: "Si tienes dudas sobre cómo agendar una cita, comunícate con el colegio:",
  },

  de: {
    panel_titulo: "Terminsystem",
    panel_bienvenido: "Willkommen",
    panel_regresar: "← Zurück",
    panel_cerrar_sesion: "Abmelden",
    panel_seleccione_servicio: "Wählen Sie einen Dienst",
    panel_ver_mis_citas: "📋 Meine Termine ansehen",
    panel_ingresar: "Auswählen",
    panel_cargando_servicios: "Dienste werden geladen...",
    panel_cargando_usuario: "Benutzer wird geladen...",
    panel_idioma: "Sprache",

    lista_titulo: "Wählen Sie die Lehrkraft für Ihren Termin",
    lista_buscar: "🔍 Lehrkraft suchen...",
    lista_cargando: "Lehrkräfte werden geladen...",
    lista_docentes_de: "Lehrkräfte",
    lista_horarios_disponibles: "Termine",
    lista_no_horarios: "Keine Termine verfügbar",
    lista_ver_horarios: "Ansehen",
    lista_sin_horarios_btn: "Ansehen",

    kinder_cargando: "Lehrkräfte werden geladen...",
    kinder_titulo: "Wählen Sie die Lehrkraft für Ihren Termin",
    kinder_buscar: "Lehrkraft suchen...",
    kinder_ver_horarios: "Ansehen",
    kinder_disponibles: "Termine",

    cda_bienvenida: "Willkommen, liebe Eltern",
    cda_subtitulo:
      "Wählen Sie die Klassenlehrkraft der Klasse, in der sich der Schüler/die Schülerin befindet.",
    cda_subtitulo2: "Sie können nur eine Lehrkraft für Ihren Termin auswählen.",
    cda_buscar: "🔍 Lehrkraft suchen...",
    cda_cargando: "Wird geladen...",
    cda_sin_foto: "Kein Foto",
    cda_ver_horarios: "Ansehen",
    cda_sin_horarios: "Ansehen",
    cda_disponibles: "Termine",
    cda_sin_resultados: "Keine Lehrkraft mit diesem Namen gefunden.",
    nivel_kinder: "Kindergarten",
    nivel_primaria: "Grundschule",
    nivel_secundaria: "Sekundarschule",

    horarios_titulo: "Wählen Sie ein verfügbares Datum",
    horarios_fecha_seleccionada: "Termine für {fecha}",
    horarios_matutino: "☀️ Vormittag",
    horarios_vespertino: "🌇 Nachmittag",
    horarios_volver: "Zurück",

    reserva_confirmada_titulo: "Termin bestätigt!",
    reserva_confirmada_subtitulo: "Ihr Termin wurde erfolgreich registriert",
    reserva_fecha: "📅 Datum:",
    reserva_hora: "⏰ Uhrzeit:",
    reserva_alumno: "👦 Schüler/in:",
    reserva_grado: "🎓 Klasse:",
    reserva_volver_inicio: "Zurück zum Start",
    reserva_detalles_titulo: "Termindetails",
    reserva_nombre_alumno_label: "👦 Name des Schülers/der Schülerin",
    reserva_grado_label: "🎓 Klasse",
    reserva_comentario_label: "📝 Kommentar",
    reserva_confirmar_btn: "Termin bestätigen",
    reserva_confirmando: "Wird gebucht...",
    reserva_volver: "Zurück",
    reserva_atencion_titulo: "Achtung",
    reserva_atencion_texto: "Bitte geben Sie den Namen des Schülers/der Schülerin und die Klasse an",
    reserva_error_titulo: "Fehler",
    reserva_error_texto: "Der Termin konnte nicht gebucht werden",

    miscitas_titulo: "📋 Meine Termine",
    miscitas_subtitulo: "Die Termine, die Sie mit den Lehrkräften vereinbart haben.",
    miscitas_regresar: "← Zurück",
    miscitas_ver_pendientes: "📌 Anstehende ansehen",
    miscitas_ver_historial: "📚 Verlauf ansehen",
    miscitas_cargando: "Wird geladen...",
    miscitas_sin_pendientes: "Sie haben keine anstehenden Termine.",
    miscitas_sin_historial: "Sie haben keine Termine im Verlauf.",
    miscitas_alumno: "👦 Schüler/in:",
    miscitas_grado: "🎒 Klasse:",
    miscitas_profesor: "👨‍🏫 Lehrkraft:",
    miscitas_fecha: "📅 Datum:",
    miscitas_hora: "🕒 Uhrzeit:",
    miscitas_nota: "💬 Notiz:",
    miscitas_anterior: "‹ Zurück",
    miscitas_siguiente: "Weiter ›",

    estado_pendiente: "Anstehend",
    estado_atendida: "Wahrgenommen",
    estado_no_asistio: "Nicht erschienen",
    estado_cancelada_admin: "Von der Verwaltung storniert",
    estado_cancelada_profesor: "Von der Lehrkraft storniert",
    estado_sin_estado: "Kein Status",

    // Vorlage "Seitliches Portal"
    portal_inicio: "Start",
    portal_mis_citas: "Meine Termine",
    portal_nueva_cita: "Neuer Termin",
    portal_ayuda: "Hilfe",
    portal_padre_familia: "Erziehungsberechtigte/r",
    portal_bienvenido: "Willkommen",
    portal_que_deseas: "Was möchten Sie heute tun?",
    portal_agendar_titulo: "Neuen Termin buchen",
    portal_agendar_desc: "Wählen Sie Dienst, Lehrkraft, Datum und Uhrzeit, die Ihnen am besten passen.",
    portal_agendar_btn: "Beginnen",
    portal_vercitas_titulo: "Meine Termine ansehen",
    portal_vercitas_desc: "Sehen Sie den Status Ihrer gebuchten Termine ein.",
    portal_vercitas_btn: "Termine ansehen",
    portal_aviso_titulo: "Wichtiger Hinweis",
    portal_aviso_texto:
      "Bitte kommen Sie 5 Minuten vor Ihrem Termin. Falls Sie nicht teilnehmen können, informieren Sie die Lehrkraft rechtzeitig.",
    portal_servicios_titulo: "Welche Art von Termin möchten Sie buchen?",
    portal_servicios_sub: "Wählen Sie den gewünschten Dienst.",
    portal_continuar: "Weiter →",
    portal_duracion_nota: "Jeder Termin dauert {min} Minuten.",
    portal_info_estudiante: "Angaben zum Schüler/zur Schülerin",
    portal_nombre_completo: "Vollständiger Name",
    portal_grado_curso: "Klasse",
    portal_comentario_opcional: "Kommentar (optional)",
    portal_tipo_servicio: "Art des Termins:",
    portal_verificacion_nota: "Nach der Bestätigung erhalten Sie eine Bestätigungs-E-Mail mit den Termindetails.",
    portal_ayuda_titulo: "Brauchen Sie Hilfe?",
    portal_ayuda_texto: "Bei Fragen zur Terminbuchung wenden Sie sich bitte an die Schule:",
  },

  en: {
    panel_titulo: "Appointment System",
    panel_bienvenido: "Welcome",
    panel_regresar: "← Back",
    panel_cerrar_sesion: "Log out",
    panel_seleccione_servicio: "Select a Service",
    panel_ver_mis_citas: "📋 View my appointments",
    panel_ingresar: "Enter",
    panel_cargando_servicios: "Loading services...",
    panel_cargando_usuario: "Loading user...",
    panel_idioma: "Language",

    lista_titulo: "Select the teacher you want to book an appointment with",
    lista_buscar: "🔍 Search teacher...",
    lista_cargando: "Loading teachers...",
    lista_docentes_de: "Teachers",
    lista_horarios_disponibles: "Slots",
    lista_no_horarios: "No time slots available",
    lista_ver_horarios: "View",
    lista_sin_horarios_btn: "View",

    kinder_cargando: "Loading teachers...",
    kinder_titulo: "Select the Teacher to Book Your Appointment",
    kinder_buscar: "Search teacher...",
    kinder_ver_horarios: "View",
    kinder_disponibles: "Slots",

    cda_bienvenida: "Welcome, Parents",
    cda_subtitulo: "Select the Homeroom Teacher of the grade your child is in.",
    cda_subtitulo2: "You can only select one teacher for your appointment.",
    cda_buscar: "🔍 Search teacher...",
    cda_cargando: "Loading...",
    cda_sin_foto: "No photo",
    cda_ver_horarios: "View",
    cda_sin_horarios: "View",
    cda_disponibles: "Slots",
    cda_sin_resultados: "No teacher found with that name.",
    nivel_kinder: "Kindergarten",
    nivel_primaria: "Elementary",
    nivel_secundaria: "Secondary",

    horarios_titulo: "Select an Available Date",
    horarios_fecha_seleccionada: "Times for {fecha}",
    horarios_matutino: "☀️ Morning",
    horarios_vespertino: "🌇 Afternoon",
    horarios_volver: "Back",

    reserva_confirmada_titulo: "Appointment confirmed!",
    reserva_confirmada_subtitulo: "Your appointment was successfully booked",
    reserva_fecha: "📅 Date:",
    reserva_hora: "⏰ Time:",
    reserva_alumno: "👦 Student:",
    reserva_grado: "🎓 Grade:",
    reserva_volver_inicio: "Back to start",
    reserva_detalles_titulo: "Appointment details",
    reserva_nombre_alumno_label: "👦 Student's name",
    reserva_grado_label: "🎓 Grade",
    reserva_comentario_label: "📝 Comment",
    reserva_confirmar_btn: "Confirm Appointment",
    reserva_confirmando: "Booking...",
    reserva_volver: "Back",
    reserva_atencion_titulo: "Attention",
    reserva_atencion_texto: "You must fill in the student's name and grade",
    reserva_error_titulo: "Error",
    reserva_error_texto: "The appointment could not be booked",

    miscitas_titulo: "📋 My Appointments",
    miscitas_subtitulo: "The appointments you've booked with teachers.",
    miscitas_regresar: "← Back",
    miscitas_ver_pendientes: "📌 View upcoming",
    miscitas_ver_historial: "📚 View history",
    miscitas_cargando: "Loading...",
    miscitas_sin_pendientes: "You have no upcoming appointments.",
    miscitas_sin_historial: "You have no appointments in your history.",
    miscitas_alumno: "👦 Student:",
    miscitas_grado: "🎒 Grade:",
    miscitas_profesor: "👨‍🏫 Teacher:",
    miscitas_fecha: "📅 Date:",
    miscitas_hora: "🕒 Time:",
    miscitas_nota: "💬 Note:",
    miscitas_anterior: "‹ Previous",
    miscitas_siguiente: "Next ›",

    estado_pendiente: "Upcoming",
    estado_atendida: "Attended",
    estado_no_asistio: "No show",
    estado_cancelada_admin: "Cancelled by administration",
    estado_cancelada_profesor: "Cancelled by the teacher",
    estado_sin_estado: "No status",

    // "Sidebar Portal" template
    portal_inicio: "Home",
    portal_mis_citas: "My appointments",
    portal_nueva_cita: "New appointment",
    portal_ayuda: "Help",
    portal_padre_familia: "Parent",
    portal_bienvenido: "Welcome",
    portal_que_deseas: "What would you like to do today?",
    portal_agendar_titulo: "Book a new appointment",
    portal_agendar_desc: "Choose the service, teacher, date and time that work best for you.",
    portal_agendar_btn: "Get started",
    portal_vercitas_titulo: "View my appointments",
    portal_vercitas_desc: "Check the status of your booked appointments.",
    portal_vercitas_btn: "View appointments",
    portal_aviso_titulo: "Important notice",
    portal_aviso_texto:
      "Please arrive 5 minutes before your appointment. If you can't attend, let the teacher know in advance.",
    portal_servicios_titulo: "What type of appointment do you want to book?",
    portal_servicios_sub: "Select the service you need.",
    portal_continuar: "Continue →",
    portal_duracion_nota: "Each appointment lasts {min} minutes.",
    portal_info_estudiante: "Student information",
    portal_nombre_completo: "Full name",
    portal_grado_curso: "Grade",
    portal_comentario_opcional: "Comment (optional)",
    portal_tipo_servicio: "Service type:",
    portal_verificacion_nota: "Once confirmed, you'll receive a confirmation email with the appointment details.",
    portal_ayuda_titulo: "Need help?",
    portal_ayuda_texto: "If you have questions about booking an appointment, contact the school:",
  },
};

export default translations;
